module.exports = __webpack_public_path__ + "images/growth-inst3.png";